import React, { useState, useEffect } from "react";
import { NotificationService } from "../../services";
import { AuthService } from "../../services";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { formatDateENGB, handleConsoleError } from "../../utils/common-methods";

const NotificationPopup = () => {
  const loginUser = AuthService.getLoginUser();
  const [filteredData, setFilteredData] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getDataByUserId();
  }, []);

  const getDataByUserId = async () => {
    const userId = loginUser?.id;
    try {
      const res = await NotificationService.getNotificationbyUserid(userId);
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
      }
    } catch (error) {
     const message=  handleConsoleError(error);
       toast.error(error?.message|| message);
    }
  };

  const getDataById = async (id) => {
    try {
      const res = await NotificationService.getNotificationbyId(id);
      if (res?.isSuccess) {
        setSelectedNotification(res?.data);
        // const modal = new window.bootstrap.Modal(document.getElementById("notificationModal"));
        // modal.show();
        setShowModal(true);
      }
      // else{
      //    toast.error(
      //             res?.message || res?.Errors?.[0]?.Message || "Something went wrong",
      //           );
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedNotification(null);
    getDataByUserId();
    window.location.reload();
  };

  const truncateHTML = (html, length) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    return textContent.length > length
      ? textContent.slice(0, length) + "..."
      : textContent;
  };

  return (
    <div className="relative">
      <section className="notification-main">
        <div className="container">
          <div className="notification-popup">
            {filteredData.length > 0 ? (
              filteredData.map((notification, index) => {
                return (
                  <div className="notification" key={notification?.id}>
                    <div className="notification-icon">
                      <div className="bell-icons1">
                        <i
                          className={`fa-solid fa-bell ${
                            !notification?.status ? "active" : ""
                          }`}
                        ></i>
                      </div>
                      {/* <p>{notification.message}</p> */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: truncateHTML(notification?.message, 80),
                        }}
                      ></p>
                      <p>
                        <span>{formatDateENGB(notification?.createdOn)}</span>
                      </p>
                    </div>
                    <div className="button-container">
                      <button
                        className="allow-btn"
                        onClick={() => getDataById(notification?.id)}
                      >
                        View
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No notifications available.</p>
            )}
          </div>
        </div>
      </section>

      {/* Bootstrap Modal */}
      {/* <div className="modal fade" id="notificationModal" tabIndex="-1" aria-labelledby="notificationModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="notificationModalLabel">Notification Details</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {selectedNotification ? (
                <>
                  <p>{selectedNotification.message}</p>
                 
                </>
              ) : (
                <p>Loading...</p>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  onClick={getDataByUserId} >
                Close 
              </button>
            </div>
          </div>
        </div>
      </div> */}

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        className="custom-contract-modal"
        centered       
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "large" }}>
          {selectedNotification ? (
            <>
              <p
                dangerouslySetInnerHTML={{
                  __html: selectedNotification?.message,
                }}
              ></p>
              <p style={{ fontSize: "small", color: "gray" }}>
                {selectedNotification?.createdOn}
              </p>
            </>
          ) : (
            "Loading..."
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "#f75c9b",
              border: "1px solid #f1327f",
              fontSize: "18px",
              padding: "7px 25px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NotificationPopup;
